import { useTranslation } from 'react-i18next';
import { signInWithRedirect } from 'aws-amplify/auth';

export default function LoggedOutPage() {
  const { t } = useTranslation(['auth', 'common']);

  const handleLogin = () => {
    // Clear the logout flag before redirecting to SSO
    sessionStorage.removeItem('intentionalLogout');
    signInWithRedirect({ provider: { custom: 'AzureAD' } });
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex flex-col items-center justify-center">
      <div className="flex flex-col items-center max-w-md text-center px-4">
        <img
          src="/uel-crest.webp"
          alt=""
          aria-hidden="true"
          className="w-24 h-24 object-contain mb-4"
        />
        <h1 className="text-2xl font-bold text-uel-purple-700 dark:text-uel-purple-400 mb-2">
          {t('common:appName')}
        </h1>
        <p className="text-gray-600 dark:text-gray-400 text-sm mb-8">
          {t('common:appFullName')}
        </p>

        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-8 w-full">
          <div className="mb-6">
            <svg
              className="w-16 h-16 mx-auto text-green-500 mb-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
              {t('auth:signedOutTitle')}
            </h2>
            <p className="text-gray-600 dark:text-gray-400">
              {t('auth:signedOutMessage')}
            </p>
          </div>

          <button
            onClick={handleLogin}
            className="w-full flex items-center justify-center px-6 py-3 text-base font-medium text-white bg-uel-purple-600 rounded-lg hover:bg-uel-purple-700 transition-colors"
          >
            <svg
              className="w-5 h-5 mr-2"
              fill="currentColor"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path d="M11.5 2.19a10.55 10.55 0 0 0-10.55 10.55 10.55 10.55 0 0 0 10.55 10.55 10.55 10.55 0 0 0 10.55-10.55A10.55 10.55 0 0 0 11.5 2.19zM1 12.74h4.94v4.94H1v-4.94zm0-5.68h4.94v4.94H1V7.06zm5.68 5.68h4.94v4.94H6.68v-4.94zm0-5.68h4.94v4.94H6.68V7.06z"/>
            </svg>
            {t('auth:signInWithUEL')}
          </button>
        </div>

        <p className="mt-6 text-xs text-gray-500 dark:text-gray-500">
          {t('common:universityOfEastLondon')}
        </p>
      </div>
    </div>
  );
}
